import { Button, Typography } from 'antd';

import styles from './styles.module.css';

const NoResults = ({ cleanFilters }: { cleanFilters: () => void }) => {
  return (
    <div className={styles.container}>
      <Typography.Title level={4}>Nenhum evento encontrado na sua busca</Typography.Title>
      <Typography.Text>Seguimos expandindo nossa agenda constantemente. Acompanhe as atualizações.</Typography.Text>
      <Button onClick={cleanFilters} size='large' className={styles.button}>
        Ver outros eventos
      </Button>
    </div>
  );
};

export default NoResults;
